import { render, staticRenderFns } from "./purchaseView.vue?vue&type=template&id=4a879c94&scoped=true"
import script from "./purchaseView.vue?vue&type=script&lang=js"
export * from "./purchaseView.vue?vue&type=script&lang=js"
import style0 from "./purchaseView.vue?vue&type=style&index=0&id=4a879c94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a879c94",
  null
  
)

export default component.exports